import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconMoreVertical: OSKIconDefinition = {
  name: 'more-vertical',
  content: '<circle cx="12" cy="12" r="1" /><circle cx="12" cy="5" r="1" /><circle cx="12" cy="19" r="1" />'
};
